import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusBadgeStatus } from '@xxtract/ui';
import type { ServiceState } from '../orders.api';

const STATE_TO_BADGE_STATUS: Record<ServiceState, StatusBadgeStatus> = {
  active: 'service-in-progress',
  onhold: 'service-on-hold',
  canceled: 'service-closed',
  completed: 'service-completed',
};

/** Status is always icon + label + color (NFR9/UX-DR1) — never color alone. */
export function OrderStatusBadge({ state }: { state: ServiceState }) {
  const { t } = useTranslation();
  return <StatusBadge status={STATE_TO_BADGE_STATUS[state]} label={t(`orders.state.${state}`)} />;
}
